
import {Application} from "../application/application";
import {JoinedRoomData} from "../chatserver/sx-server";
import logging from "../utils/log";

export class RegIncentive
{
	waitTimer: number;
	private phase;
	private phases = [120 * 1000, 90 * 1000, 60 * 1000, 30 * 1000, 30 * 1000];
	private TAG: string = "[RegIncentive]";
	private resetStreamTimeout: number;
	private static TAG_TIME: string = "regIncentiveLastTime2";
	private static TAG_PHASE: string = "regIncentiveLastPhase2";
	private c: string = "console";

	constructor(private app : Application)
	{
		const lastRegNagTS = this.app.storage.get(RegIncentive.TAG_TIME, null);

		this.phase = lastRegNagTS && Date.now() < lastRegNagTS + 24 * 3600 * 1000
			? this.app.storage.get(RegIncentive.TAG_PHASE, 0) * 1
			: 0;
	}

	enteredToRoom(ignoreZeroTime = false)
	{
		// if (1 === 1) return;
		const timeout = this.phases.length > this.phase
			? this.phases[this.phase]
			: 0;

		if (ignoreZeroTime && !timeout ) {
			return;
		}

		window[this.c].log(this.TAG, "Entered to room", timeout, this.isRegPanelVisible());

		clearTimeout(this.waitTimer);

		if (this.isRegPanelVisible())
		{
			this.resetStream();
		}
		else
		{
			this.waitTimer = setTimeout(() => {

				window[this.c].log(this.TAG, "Entered to room timer reached", this.isRegPanelVisible());

				if (!this.isRegPanelVisible())
				{
					this.showRegPanel();
					this.phase++;
					this.app.storage.set(RegIncentive.TAG_TIME, Date.now());
					this.app.storage.set(RegIncentive.TAG_PHASE, this.phase);
				}

			}, timeout);
		}
	}

	showRegPanel()
	{
		window[this.c].log(this.TAG, "Showing panel");

		const isGameOver = this.phases.length - 1 <= this.phase;

		if (!isGameOver)
		{
			this.app.receiver.setFlag("sxccs-float-over-reg", true);

			this.app.receiver.evt.on("mouseenter", () => {
				this.app.view.authPanel.shakeButton();
				this.app.receiver.setFlag("sxccs-float-over-reg-mini", true);
			});

			this.app.receiver.evt.on("mouseleave", () => {
				this.app.receiver.setFlag("sxccs-float-over-reg-mini", false);
			});

			clearTimeout(this.resetStreamTimeout);

			this.resetStreamTimeout = setTimeout(() => {
				this.resetStream();
			}, 60000);
		}
		else
		{
			this.app.view.authPanel.setGameOver();
		}

		this.app.showRegister(() =>
		{
			window[this.c].log(this.TAG, "Closing panel");
			this.resetStream();

			if (isGameOver) {
				window[this.c].log(this.TAG, "Closing app");
				this.app.close();
			} else {
				setTimeout(() => {
					if (this.app.chatServer.currentRoom) {
						window[this.c].log(this.TAG, "Resetting counter");
						this.enteredToRoom(true);
					}
				}, 500);
			}

			setTimeout(() => {
				if (this.app.chatServer.currentRoom) {
					window[this.c].log(this.TAG, "Resetting counter");
					this.enteredToRoom(true);
				}
			}, 500);
		}, true);
	}

	isRegPanelVisible()
	{
		return this.app.view.authPanel.isVisible();
	}

	removedFromRoom()
	{
		window[this.c].log(this.TAG, "removed from room");
		clearTimeout(this.waitTimer);
		this.resetStream();
	}

	resetStream()
	{
		clearTimeout(this.resetStreamTimeout);

		if(typeof this.app.options.chatIncludeType != 'undefined') { return; }

		this.app.receiver.evt.off("mouseenter");
		this.app.receiver.evt.off("mouseleave");
		this.app.receiver.setFlag("sxccs-float-over-reg", false);
		this.app.receiver.setFlag("sxccs-float-over-reg-mini", false);
	}
}
